module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets//tiger_5_3.png?v=f02e217f";